import { Link } from "react-router-dom";
import { useChampionship } from "@/context/ChampionshipContext";

export default function Footer() {
  const { current } = useChampionship() || {};
  return (
    <footer className="bg-[#0A0A0A] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="relative w-10 h-10">
              <div className="absolute inset-0 rounded-full othello-disc-dark border border-white/20" />
              <div className="absolute top-0 left-0 w-5 h-5 rounded-full othello-disc border border-neutral-300" />
            </div>
            <div>
              <div className="font-display font-extrabold tracking-tight text-xl">
                WOC {current?.year || ""}
              </div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-white/60">
                {current?.location} — {current?.country}
              </div>
            </div>
          </div>
          <p className="mt-6 text-white/70 text-sm max-w-md leading-relaxed">
            The World Othello Championship is the pinnacle of competitive Othello, bringing together
            the strongest players from every continent for a four-day battle of strategy and skill.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-[11px] uppercase tracking-[0.22em] text-white/50 mb-5">Tournament</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/teams" className="hover:text-primary transition-colors">Teams</Link></li>
            <li><Link to="/news" className="hover:text-primary transition-colors">News</Link></li>
            <li><Link to="/info/venue" className="hover:text-primary transition-colors">Venue</Link></li>
            <li><Link to="/info/schedule" className="hover:text-primary transition-colors">Schedule</Link></li>
            <li><Link to="/info/prizes" className="hover:text-primary transition-colors">Prizes</Link></li>
            <li><Link to="/partners" className="hover:text-primary transition-colors">Partners</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[11px] uppercase tracking-[0.22em] text-white/50 mb-5">Federation</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="https://www.worldothello.org" target="_blank" rel="noreferrer" className="hover:text-primary">WOF</a></li>
            <li><Link to="/register" className="hover:text-primary">Captain Sign Up</Link></li>
            <li><Link to="/login" className="hover:text-primary">Sign In</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-[11px] uppercase tracking-[0.22em] text-white/50 mb-5">Live</h4>
          {current?.live_stream_url && (
            <a href={current.live_stream_url} target="_blank" rel="noreferrer" className="block text-sm hover:text-primary">
              YouTube Stream
            </a>
          )}
          {current?.live_standings_url && (
            <a href={current.live_standings_url} target="_blank" rel="noreferrer" className="block text-sm hover:text-primary mt-2">
              Live Standings
            </a>
          )}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} World Othello Federation. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <span>An official World Championship event.</span>
            <span className="hidden md:inline text-white/20">·</span>
            <a
              href="https://app.emergent.sh/?utm_source=emergent-badge"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white/80 transition-colors"
            >
              Built with Emergent
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
